import React from 'react'
import SettingsMetaData from '../../../../../Components/Hooks/useSettingsMetaData'

const LeadTime = () => {
  return (
    <SettingsMetaData propertyName={"LeadTime_Supplierqoutes"} viewPropertyName={"Lead Time"} />

  )
}

export default LeadTime